
import { FrontendFunc } from "@/models/frontend-func";
import { FrontendScriptsService } from "@/services/frontend-scripts-service";
import Vue from "vue";
import AppFrontendFuncParameterList from "@/components/FrontendFuncParameterList.vue";
import "codemirror/mode/javascript/javascript";

export default Vue.extend({
	data(){
		return {
			script: new FrontendFunc(),
			paramNamesValid: false,
			isSaving: false
		};
	},
	computed: {
		title():string{
			if (this.script.ID == 0) {
				return "Nieuwe frontend functie";
			}
			return "Frontend functie bewerken";
		},
		nameValid():boolean {
			return FrontendFunc.validNameRegex.test(this.script.Name);
		},
		valid():boolean {
			if (!this.nameValid) return false;
			if (!this.paramNamesValid) return false;
			return true;
		},
		cmOptions():any{
			return {
				mode: "text/javascript"
			};
		},
	},
	methods: {
		async save(){
			console.log("Save clicked");
			if (!this.valid) return;
			console.log("Valid");
			if (this.isSaving) return;
			console.log("Not saving");
			this.isSaving = true;
			try{
				if (this.script.ID == 0){
					this.script = await FrontendScriptsService.createFrontendSharedFunc(this.script);
				}else{
					this.script = await FrontendScriptsService.updateFrontendSharedFunc(this.script);
				}
				this.$wf.notify("Success", "success", 3000, "check");
			}catch(err){
				console.error(err);
			}
			this.isSaving = false;
		}
	},
	async created(){
		let id = parseInt(this.$route.params.id);
		if (Number.isNaN(id)) return;
		this.script = await FrontendScriptsService.getFrontendSharedFuncById(id);
	},
	components: {
		AppFrontendFuncParameterList
	}
});
